import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { MINIMUM_PASSWORD_LENGTH } from '../../../shared/consts';

const MSG = {
  isRequired: 'Password is required',
  isLength: `Password must be at least ${MINIMUM_PASSWORD_LENGTH} characters`,
  matches: 'Password must include at least 1 digit',
};

export default function Password({
  Field, Err, useInput, errors, peekaboo, focus, validateComplexity,
}) {
  const fieldRef = React.useRef();
  const [hidden, setHidden] = React.useState(true);

  React.useEffect(() => {
    fieldRef.current[focus ? 'focus' : 'blur']();
  }, [focus]);

  const toggle = evt => {
    evt && evt.preventDefault();
    setHidden(!hidden);
  };

  const peekabooCls = classNames(
    'icon-lw',
    {
      'icon-lw-password-hide': hidden,
      'icon-lw-password-show': !hidden,
    },
  );

  /* eslint-disable jsx-a11y/no-static-element-interactions */
  return (
    <React.Fragment>
      <Field
        ref={fieldRef}
        type={hidden ? 'password' : 'text'}
        placeholder="password"
        style={{ paddingRight: peekaboo ? '50px' : 'auto' }}
        {...useInput('password', {
          isRequired: true,
          ...(!validateComplexity ? {} : {
            isLength: { min: MINIMUM_PASSWORD_LENGTH },
            matches: /[0-9]/,
          }),
        })}
      />
      {!!peekaboo && <span className={peekabooCls} onClick={toggle} />}
      {!!errors.password && <Err>{MSG[errors.password]}</Err>}
    </React.Fragment>
  );
  /* eslint-enable jsx-a11y/no-static-element-interactions */
}

Password.propTypes = {
  Field: PropTypes.elementType.isRequired,
  Err: PropTypes.elementType.isRequired,
  useInput: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    password: PropTypes.string,
  }),
  peekaboo: PropTypes.bool,
  focus: PropTypes.bool,
  validateComplexity: PropTypes.bool,
};

Password.defaultProps = {
  errors: { password: null },
  peekaboo: false,
  focus: false,
  validateComplexity: true,
};
